import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { w, v } from '@dojo/framework/core/vdom';
import css from '../css/lptool.m.css';
let LPToolbar = class LPToolbar extends I18nThemed {
    render_kids(kids) {
        return kids.map((kid) => {
            const { widget } = kid;
            const params = { ...kid };
            delete params['widget'];
            return w(widget, { ...params });
        });
    }
    render() {
        const { classes = [], name, element = 'ul', kids } = this.properties;
        return v(element, {
            key: name,
            role: 'menubar',
            classes: [this.theme(css.root), ...classes],
            xqa: `lptool ${name}`,
            onclick: (evt) => {
                evt && evt.stopPropagation();
            }
        }, this.render_kids(kids));
    }
};
LPToolbar = __decorate([
    theme(css)
], LPToolbar);
export { LPToolbar };
export default LPToolbar;
